import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";

const HappyCustomerCount = () => {
  const { t } = useAppTranslation("pages.reviews");

  return (
    <Group
      className="absolute top-3 xs:top-10 z-10 w-fit rounded-xl bg-primary-background p-2 font-secret-bold-wide font-semibold text-white max-xs:right-0 max-xs:left-0 max-xs:m-auto"
      justify="center"
      align="center"
    >
      <AppThemeIcon className="size-5">
        <Icon.Star size={26} className="pb-0.5" />
      </AppThemeIcon>
      {t("happyCustomerCount")}
    </Group>
  );
};

export default HappyCustomerCount;
